import {
    convertTableJsonToAsset,
    getAPIGatewayPostRequest,
    getNodeId,
    logOperationalMetric,
    macToThingName, thingNameToMac
} from "../../../util/Util";
import {
    ACTIVE, ALERT_ASSET_STATUS_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE, ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS,
    ENDPOINT_GET_THIN_CLIENT_STATUS, INACTIVE, LOADING_FAILED,
    THIN_CLIENT_ASSET_TYPE
} from "../../../util/Constants";
import {getAssetByAssetLabel, getAssets, setAssetStatus, updateAsset} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";

export const metricProcessName = "THIN_CLIENT_DEVICE_DETAILS";

export function fetchThinClientDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: THIN_CLIENT_ASSET_TYPE
    }
    getThinClientDeviceDetails(dispatcher, request)
}

export function setThinClientDeviceDetails(dispatcher, stateValues, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    updateThinClientDeviceDetails(dispatcher, request, stateValues)
}

export function deleteThinClientDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: INACTIVE
    }
    setAssetLabelInactiveThinClientDeviceDetails(dispatcher, request)
}

export const extractThinClientDeviceList = (result) => {
    const model = {
        thinClientDeviceInformation: {},
        macAddressArray: [],
        gatewayNameList: []
    }
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((thinClientDeviceDetail) => {
            if (thinClientDeviceDetail.assetStatus === ACTIVE) {
                model.gatewayNameList.push(macToThingName(thinClientDeviceDetail.assetAttributes.mac))
                model.macAddressArray.push(thinClientDeviceDetail.assetAttributes.mac)
                model.thinClientDeviceInformation[thinClientDeviceDetail.assetAttributes.mac] = {
                    name: thinClientDeviceDetail.assetAttributes.name,
                    mac: thinClientDeviceDetail.assetAttributes.mac,
                    ip: thinClientDeviceDetail.assetAttributes.ip,
                    vlan: thinClientDeviceDetail.assetAttributes.vlan,
                    usecase: thinClientDeviceDetail.assetAttributes.usecase,
                    primary_secondary: thinClientDeviceDetail.assetAttributes.primary_secondary,
                    remark: thinClientDeviceDetail.assetAttributes.remark,
                    startTime: thinClientDeviceDetail.assetAttributes.startTime,
                    endTime: thinClientDeviceDetail.assetAttributes.endTime,
                    reason: thinClientDeviceDetail.assetAttributes.reason
                }
            }
        });
    }
    return model;
}

export const getThinClientDeviceSoftwareStatusDetails = (dispatcher, model) => {
    const request = {
        gatewayNameList: model.gatewayNameList
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS);
    getAPIGatewayDataFromParent(args).then(response => {
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", true);
            mergeSoftwareStatusToModel(response, model)
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", false);
            model.macAddressArray.forEach((macAddress) => {
                model.thinClientDeviceInformation[macAddress].swstatus = LOADING_FAILED
            })
        }
    }).catch(() => {
        model.macAddressArray.forEach((macAddress) => {
            model.thinClientDeviceInformation[macAddress].swstatus = LOADING_FAILED
        })
    });
    model.macAddressArray.forEach((macAddress) => {
        if (!model.thinClientDeviceInformation[macAddress].swstatus) {
            model.thinClientDeviceInformation[macAddress].swstatus = LOADING_FAILED
        }
    })
    return model;
}

export const updateThinClientDeviceList = async (result, stateValues, dispatcher) => {
    result.assetDetails.assetAttributes.startTime = stateValues.startTime
    result.assetDetails.assetAttributes.endTime = stateValues.endTime
    result.assetDetails.assetAttributes.reason = stateValues.reason
    const responseSetAssetStatus = await setAssetStatus(result.assetDetails.assetLabel, ACTIVE);
    if (responseSetAssetStatus.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
    } else if (responseSetAssetStatus.status === 200) {
        const responseUpdateAsset = await updateAsset(result);
        if (responseUpdateAsset.status !== 200) {
            alert(ALERT_UPDATE_ASSET_MESSAGE);
        }
    }
    fetchThinClientDeviceDetails(dispatcher)
}

async function getThinClientDeviceStatusDetails(dispatcher, model) {
    model = getThinClientDeviceSoftwareStatusDetails(dispatcher, model)
    const request = {
        nodeId: getNodeId()
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_THIN_CLIENT_STATUS);
    getAPIGatewayDataFromParent(args).then(response => {
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", true);
            mergeStatusToModel(response, model)
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAslDeviceStatusDetails", false);
            model.macAddressArray.forEach((macAddress) => {
                model.thinClientDeviceInformation[macAddress].connection = LOADING_FAILED
                model.thinClientDeviceInformation[macAddress].healthstatus = LOADING_FAILED
            })
        }
    }).catch(() => {
        model.macAddressArray.forEach((macAddress) => {
            model.thinClientDeviceInformation[macAddress].connection = LOADING_FAILED
            model.thinClientDeviceInformation[macAddress].healthstatus = LOADING_FAILED
        })
    });
    model.macAddressArray.forEach((macAddress) => {
        if (!(model.thinClientDeviceInformation[macAddress].connection && model.thinClientDeviceInformation[macAddress].healthstatus)) {
            model.thinClientDeviceInformation[macAddress].connection = LOADING_FAILED
            model.thinClientDeviceInformation[macAddress].healthstatus = LOADING_FAILED
        }
    })
    dispatcher({type: "RECEIVE_DATA", data: model});
}

async function setAssetLabelInactiveThinClientDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteThinClientDeviceDetails", true);
        } else {
            logOperationalMetric(startTime, metricProcessName, "deleteThinClientDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function getThinClientDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    getAssets(request.nodeId, request.assetType).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceDetails", true);
            getThinClientDeviceStatusDetails(dispatcher, extractThinClientDeviceList(result))
        } else {
            logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

async function updateThinClientDeviceDetails(dispatcher, request, stateValues) {
    const startTime = Date.now();
    getAssetByAssetLabel(request.assetLabel).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "updateThinClientDeviceDetails", true);
            dispatcher({
                type: "RECEIVE_DATA",
                data: updateThinClientDeviceList(result.data.asset, stateValues, dispatcher)
            });
        } else {
            logOperationalMetric(startTime, metricProcessName, "updateThinClientDeviceDetails", false);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function postUpdatedRemarkToDevice(device, newRemark) {
    const newAsset = convertTableJsonToAsset({...device, remark: newRemark}, THIN_CLIENT_ASSET_TYPE, ACTIVE);
    const responseUpdateAsset = await updateAsset(newAsset);
    if (responseUpdateAsset.status !== 200) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "thinClientStatusList" in response.data) {
        response.data.thinClientStatusList.forEach((singleThinClientDeviceStatusDetail) => {
            // convert thingName tc-ababababab-DBE2_Core format to mac address ab:ab:ab:ab:ab
            const mac = thingNameToMac(singleThinClientDeviceStatusDetail.thingName)
            model.thinClientDeviceInformation[mac].connection = singleThinClientDeviceStatusDetail.connectionStatus
            model.thinClientDeviceInformation[mac].healthstatus = singleThinClientDeviceStatusDetail.deepHealthStatus
        })
    }
}

function mergeSoftwareStatusToModel(response, model) {
    if ("data" in response && "thinClientStatusList" in response.data) {
        response.data.thinClientDeploymentList.forEach((singleThinClientDeviceSoftwareStatusDetail) => {
            // convert thingName tc-ababababab-DBE2_Core format to mac address ab:ab:ab:ab:ab
            const mac = thingNameToMac(singleThinClientDeviceSoftwareStatusDetail.thingName)
            model.thinClientDeviceInformation[mac].swstatus = singleThinClientDeviceSoftwareStatusDetail.deploymentStatus
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/network/ThinClientOverviewNetworkAPI.js